export default __webpack_public_path__ + "static/media/cymp_profile.84908196.png";